import React from "react";
import { Box, Paper, Typography } from "@mui/material";
import {
  getContainerStyle,
  getItemPaperStyle,
  getItemRowStyle,
  getDisplayNameStyle,
  getLtpStyle,
  getChangeColumnStyle,
  getAbsoluteChangeStyle,
  getPercentChangeStyle,
} from "./PinnedInstrumentsListCss";

const PinnedInstrumentsList = React.memo(({ isMobile, pinnedInstruments, dynamicInfo }) => {
  const pinsLength = pinnedInstruments?.length || 0;

  return (
    <Box
      onWheel={(e) => {
        const container = e.currentTarget;
        if (container) {
          container.scrollLeft += e.deltaY;
        }
      }}
      sx={getContainerStyle(isMobile, pinsLength)}
    >
      {pinnedInstruments.map((index) => {
        const tokenVal = index.token || index.instrumentToken || index.instrument_token;
        const displayName = index.display_name || index.trading_symbol || "";
        const data = dynamicInfo[tokenVal] || {};
        const ltp = parseFloat(data.ltp);
        const absoluteChange = parseFloat(data.absoluteChange);
        const percentChange = parseFloat(data.percentChange);

        return (
          <Paper
            key={tokenVal || displayName}
            elevation={0}
            sx={getItemPaperStyle(isMobile)}
          >
            <Box sx={getItemRowStyle()}>
              <Box>
                <Typography variant="body2" sx={getDisplayNameStyle(isMobile)}>
                  {displayName.toUpperCase()}
                </Typography>

                <Typography variant="body2" sx={getLtpStyle(isMobile)}>
                  {!isNaN(ltp) ? ltp.toFixed(2) : "-"}
                </Typography>
              </Box>

              <Box sx={getChangeColumnStyle(data.selectedClass)}>
                <Typography variant="caption" sx={getAbsoluteChangeStyle(isMobile)}>
                  {!isNaN(absoluteChange) ? absoluteChange.toFixed(2) : "-"}
                </Typography>
                <Typography variant="caption" sx={getPercentChangeStyle(isMobile)}>
                  {!isNaN(percentChange) ? `(${percentChange.toFixed(2)}%)` : "-"}
                </Typography>
              </Box>
            </Box>
          </Paper>
        );
      })}
    </Box>
  );
});

export default PinnedInstrumentsList;
